import React, { Component } from 'react';
// import MaskedInput from 'react-maskedinput';
import MaskedInput from 'react-input-mask';
import { Input } from 'antd';

// class InputMask extends MaskedInput {
//   _onKeyPress = (e) => {
//     const { onKeyDown } = this.props;
//
//     if (e.key === 'Enter') {
//       onKeyDown();
//     }
//     if (e.metaKey || e.altKey || e.ctrlKey) { return; }
//
//     e.preventDefault();
//     this._updateMaskSelection();
//     if (this.mask.input((e.key || e.data))) {
//       e.target.value = this.mask.getValue();
//       this._updateInputSelection();
//       if (this.props.onChange) {
//         this.props.onChange(e);
//       }
//     }
//   };
// }


class InputMask extends Component {
  // _onKeyPress = (e) => {
  //   const { onKeyDown } = this.props;
  //
  //   if (e.key === 'Enter') {
  //     onKeyDown();
  //   }
  //   if (e.metaKey || e.altKey || e.ctrlKey) { return; }
  //
  //   e.preventDefault();
  //   this._updateMaskSelection();
  //   if (this.mask.input((e.key || e.data))) {
  //     e.target.value = this.mask.getValue();
  //     this._updateInputSelection();
  //     if (this.props.onChange) {
  //       this.props.onChange(e);
  //     }
  //   }
  // };

  render() {
    return(
      <MaskedInput
        {...this.props}
      >
        {(_p) => <Input {..._p} ref={this.props._ref} size="large" placeholder="+7-___-___-__-__" />}
      </MaskedInput>
    );
  }
}

export default InputMask;
